import { APP_INITIALIZER } from '@angular/core';
import { ThemeService } from './theme.service';
import { CookieStorageService } from '../app/common/helpers/cookie-storage.service';

export const AppInitializerProvider = {
    provide: APP_INITIALIZER,
    useFactory: (themeService: ThemeService, cookieService: CookieStorageService) => () => {
        // Clean up any duplicate cookies from different paths
        cookieService.cleanupDuplicates();
        return themeService.loadTheme();
    },
    deps: [ThemeService, CookieStorageService],
    multi: true
};
